(function () {
  function hard(el, prop, val) { if (el) el.style.setProperty(prop, val, 'important'); }

  function layoutButtons() {
    var cont = document.querySelector('.product__info-container');
    if (!cont) return;
    var acc = cont.querySelector('shopify-accelerated-checkout');
    var pp = cont.querySelector('shopify-paypal-button');
    var mo = cont.querySelector('more-payment-options-link');
    if (!acc) return;

    hard(acc, 'display', 'block');
    hard(acc, 'width', '100%');
    hard(acc, 'font-size', '0');
    hard(acc, 'line-height', '0');
    hard(acc, 'white-space', 'nowrap');

    if (pp) {
      var accW = Math.round(acc.getBoundingClientRect().width) || 345;
      var moW = 114;
      var ppW = Math.max(180, accW - moW - 10);
      hard(pp, 'display', 'inline-block');
      hard(pp, 'vertical-align', 'top');
      hard(pp, 'width', ppW + 'px');
      hard(pp, 'max-width', ppW + 'px');
      hard(pp, 'margin', '0 8px 0 0');
      hard(pp, 'order', '1');
    }

    if (mo) {
      hard(mo, 'display', 'inline-block');
      hard(mo, 'vertical-align', 'top');
      hard(mo, 'width', '114px');
      hard(mo, 'max-width', '114px');
      hard(mo, 'margin', '0');
      hard(mo, 'min-height', '0');
      hard(mo, 'height', 'auto');
      hard(mo, 'margin', '0');
      hard(mo, 'padding', '0');
      hard(mo, 'align-items', 'center');
      var a = mo.querySelector('a');
      if (a) {
        hard(a, 'display', 'inline-flex');
        hard(a, 'width', '100%');
        hard(a, 'box-sizing', 'border-box');
        hard(a, 'align-items', 'center');
        hard(a, 'justify-content', 'center');
        hard(a, 'min-height', '4.6rem');
        hard(a, 'height', '4.6rem');
        hard(a, 'padding', '0 .8rem');
        hard(a, 'margin', '0');
        hard(a, 'border', '1px solid #B3B3AC');
        hard(a, 'border-radius', '.5rem');
        hard(a, 'background', 'linear-gradient(180deg, #FDFDFB 0%, #D9D9D3 100%)');
        hard(a, 'color', '#1B2130');
        hard(a, 'box-shadow', 'inset 0 1px 0 rgba(255,255,255,.95), 0 1px 2px rgba(0,0,0,.06)');
        hard(a, 'font-size', '1.05rem');
        hard(a, 'font-weight', '700');
        hard(a, 'letter-spacing', '.08em');
        hard(a, 'text-transform', 'uppercase');
        hard(a, 'line-height', '1');
        hard(a, 'white-space', 'nowrap');
        hard(a, 'text-decoration', 'none');
      }
    }
  }

  function reorderTax() {
    var cont = document.querySelector('.product__info-container');
    if (!cont) return;
    var tax = cont.querySelector('.product__tax');
    var card = cont.querySelector('.fs-card.free-ship') || cont.querySelector('[data-free-shipping]');
    if (!tax || !card) return;
    if (card.contains(tax)) return;
    card.appendChild(tax);
    tax.style.setProperty('margin', '.6rem 0 0', 'important');
    tax.style.setProperty('padding', '0', 'important');
    tax.style.setProperty('font-size', '1.2rem', 'important');
    tax.style.setProperty('line-height', '1.5', 'important');
    tax.style.setProperty('text-align', 'left', 'important');
    tax.style.setProperty('border', '0', 'important');
    tax.style.setProperty('background', 'none', 'important');
    tax.querySelectorAll('a').forEach(function (a) {
      a.style.setProperty('color', 'inherit', 'important');
      a.style.setProperty('text-decoration', 'underline', 'important');
      a.style.setProperty('text-underline-offset', '2px', 'important');
    });
  }

  function boot() { layoutButtons(); reorderTax(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  setTimeout(boot, 300);
  setTimeout(boot, 900);
  setTimeout(boot, 1800);
  setTimeout(boot, 3200);
  document.addEventListener('shopify:section:load', boot);
  window.addEventListener('resize', boot);
})();
